import React, { useState } from 'react';
import classes from './style.module.css'
import { HORSE_TABLE_ALL_COLUMNS_STATIC, HORSE_TABLE_COLUMNS_STATIC } from '../../../constants/Constants'
import OddResultCell from './OddResultCell'
import WinDetailCell from './WinDetailCell'
import bookIcon from "../../../assets/images/green-up-arrow.png"

const roundOff = (reating) => {
    return Math.floor(reating * 100) / 100;
}

const League = (props) => {
    const [isClicked, setIsClicked] = useState(false);

    const handleClick = () => {
        setIsClicked(true);
        setTimeout(() => setIsClicked(false), 450);
        props.clickHandler(props.item);
    };

    const rowIndex = props.index + 1;
    const id = props.item.time;
    const type = props.type;
    const columnList = props.finalColumns;

    const cells = columnList.map(column => {
        let cell = null;
        const cellKey = id + "_" + column.id
        //console.log(props.item.raceId)
        switch (column.id) {
            case HORSE_TABLE_COLUMNS_STATIC.ROW_NUM.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{rowIndex}</th>
                break;
            case HORSE_TABLE_ALL_COLUMNS_STATIC.VENUE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.raceVenue}</td>
                break;
            case HORSE_TABLE_ALL_COLUMNS_STATIC.DATE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.raceDayStr}</td>
                break;
            case HORSE_TABLE_ALL_COLUMNS_STATIC.TIME.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.raceTime}</td>
                break;
            //case HORSE_TABLE_ALL_COLUMNS_STATIC.RACE_NAME.id:
            //    cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.raceName}</td>
            //    break;
            case HORSE_TABLE_ALL_COLUMNS_STATIC.WFF_RATING.id:
                 //9999 is invalid value
                    cell = <td key={cellKey} className={classes.LeagueTdTh}>
                       
                        {props.item.wff >= -100 &&  props.item.wff != 9999 ? roundOff(props.item.wff): 'N/A'}
                    </td>
                    break;
            case HORSE_TABLE_ALL_COLUMNS_STATIC.RPR_RATING.id:
                        cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.rpr}</td>
                        break;            
            case HORSE_TABLE_COLUMNS_STATIC.DRAW.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerDraw}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.FORM.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerForm}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.LAST_FORM.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerLastForm}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.HORSE_NAME.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>
                    {props.item.runnerName}
                    {props.item.improvingHorse ? <img style={{ width: "10px", height: "10px"}} src={bookIcon} />
                      : ""}
                    </td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.RUNNER_COUNTRY.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerCountry}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.JOCKEY.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerJockey}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.TRAINER.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerTrainer}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.DATE_LAST_RUN.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerSinceLastRun}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.AGE.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerAge}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.WEIGHT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerWeight}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.BEATEN_FAV.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.beatenFavorite ? 'Y' : 'N'}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.COURSE_WINNER.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.courseWinner ? 'Y' : 'N'}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.DISTANCE_WINNER.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.distanceWinner ? 'Y' : 'N'}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.COURSE_DISTANCE_WINNER.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.courseAndDistanceWinner ? 'Y' : 'N'}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.OR.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerOR ? props.item.runnerOR : ''}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.RDB_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.runnerRdbRating}</td>
                break;
            //case HORSE_TABLE_COLUMNS_STATIC.MORNING_ODD.id:
            //    cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.morningBookieOdds}</td>
            //    break;
            //case HORSE_TABLE_COLUMNS_STATIC.MORNING_FAV.id:
            //    cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.morningFavorite}</td>
            //    break;
            //case HORSE_TABLE_COLUMNS_STATIC.RACE_DISTANCE.id:
            //    cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.race.distance}</td>
            //    break;
            case HORSE_TABLE_COLUMNS_STATIC.ODD_DETAILS.id:
                let part = props.item;
                console.log(JSON.stringify(part))
                let details = "-,-"
                if (part.bfSelectionId && part.bfMarketId) {
                    details = <OddResultCell
                        odds={props.oddsMap ? props.oddsMap[part.bfSelectionId] : undefined}
                        date={props.date} type={type}
                        oddChangeCallback={props.oddChangeCallback}
                        marketId={part.bfMarketId} selectionId={part.bfSelectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{details}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.WIN_DETAILS.id:
                let currentItem = props.item;
                let winnerDetails = "-"
                if (currentItem.bfSelectionId && currentItem.bfMarketId) {
                    winnerDetails = <WinDetailCell type={type} marketId={currentItem.bfMarketId}
                        date={props.date} time={props.time}
                        selectionId={currentItem.bfSelectionId}
                        winnerInfo={props.winnerInfo}
                        odds={props.oddsMap ? props.oddsMap[currentItem.bfSelectionId] : undefined} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{winnerDetails}</td>
                break;
            default:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>-</td>
        }
        return cell;
    })

    return (
        <tr onClick={handleClick} className={`${classes.League} ${isClicked ? classes.LeagueClicked : ''}`}>
            {cells}
        </tr>
    )
}

export default League;